export default "__VITE_ASSET__CSMfHIcz__"